import {
  snowman,
  renovation,
  summerHolidays,
  partyTime,
  travel,
  house,
} from "assets/images";

const data = [
  { name: "winter", src: snowman },
  { name: "renovation", src: renovation },
  { name: "holidays", src: summerHolidays },
  { name: "party", src: partyTime },
  { name: "travel", src: travel },
  { name: "home", src: house },
];

export default data;
